<template>
  <v-content>
    <router-view id="content-wrap" />

    <!--dashboard-core-footer
      id="dashboard-core-footer"
    /-->
    <v-img
      width="200"
      id="dashboard-core-footer"
      src="@/assets/powered-by-norven.svg"
    />
  </v-content>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
    },
  }
</script>

<style scoped>
#content-wrap{
  margin-bottom: 38px;
}
#dashboard-core-footer {
  margin:  0px 0px 8px 32px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>>
